import { useEffect, useRef, useState } from "react";
import Confetti from "react-confetti";

interface ConfettiEffectProps {
  isComplete?: boolean;
}

export const ConfettiEffect = ({ isComplete }: ConfettiEffectProps) => {
  const [shouldShowConfetti, setShouldShowConfetti] = useState(false);
  const wasComplete = useRef<boolean | undefined>(undefined);

  useEffect(() => {
    if (wasComplete.current === false && isComplete === true) {
      setShouldShowConfetti(true);
    }
    wasComplete.current = isComplete;
  }, [isComplete]);

  if (!shouldShowConfetti) return null;

  return (
    <Confetti
      width={window.innerWidth}
      height={window.innerHeight}
      recycle={false}
      tweenDuration={5000}
      numberOfPieces={300}
      style={{ zIndex: 999999 }}
    />
  );
};
